import { equalTo } from 'ngrx-forms/validation';
import { BuildValidatorWithComparandDecorator } from './helpers';

export const EqualTo = BuildValidatorWithComparandDecorator(equalTo,'DX.FORMS.VALIDATION.ERRORS.EQUAL_TO');
